import React from 'react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const MarkAsPaidMenuItem = ({ task, onMarkAsPaid = () => {} }) => {
  const { formatMessage } = useIntl()
  const handleOnClick = () => {
    if (confirm(formatMessage(!task.isPaid ? messages.confirmMarkAsPaidPrompt : messages.confirmMarkAsNotPaidPrompt))) {
      onMarkAsPaid(!task.isPaid)
    }
  }

  return (
    <Menu.Item key='markAsPaidMenuItem'>
      {(props) => (
        <MenuButton
          {...props}
          onClick={() => handleOnClick()}
          state="negative"
        >
          {!task.isPaid ? (
          <FormattedMessage {...messages.markAsPaid} />
          ) : (
            <FormattedMessage {...messages.markAsNotPaid} />
          )}
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default MarkAsPaidMenuItem
